import { GetMessagesResponse } from './api.types';

import { apiClient } from '@/services/api';

export const getChatMessages = async (
  propertyId: string,
  cursor?: string,
): Promise<GetMessagesResponse> => {
  const params = new URLSearchParams();
  if (cursor) params.set('cursor', cursor);
  const url = `/properties/${propertyId}/chat/messages${params.toString() ? `?${params}` : ''}`;
  const response = await apiClient.get<GetMessagesResponse>(url);
  return response.data;
};

export const markPropertyAsRead = async (propertyId: string): Promise<void> => {
  await apiClient.post(`/properties/${propertyId}/chat/read`);
};

export interface RecentMessage {
  messageId?: string;
  content: string;
  senderName: string;
  createdAt: number;
}

export interface UnreadGroupInfo {
  groupId: string;
  unreadCount: number;
  recentMessages: RecentMessage[];
}

export interface GroupUnreadCountsResponse {
  groups: UnreadGroupInfo[];
  totalUnread: number;
}

export const getGroupUnreadCounts = async (): Promise<GroupUnreadCountsResponse> => {
  const response = await apiClient.get<GroupUnreadCountsResponse>('/client-groups/unread-counts');
  return response.data;
};

export const mutePropertyChat = async (propertyId: string): Promise<void> => {
  await apiClient.post(`/properties/${propertyId}/chat/mute`);
};

export const unmutePropertyChat = async (propertyId: string): Promise<void> => {
  await apiClient.post(`/properties/${propertyId}/chat/unmute`);
};
